/**
 * module for location selection widget.
 */
define(
    'viewmodels/app/components/__csvDownloadForm',['knockout', 'lodash', 'atn/atn', '../__allCharts', '../analytics/__settings',
        'chartApi/index', 'chartApi/exportingApi', '../__config', '../__utils', 'jsZip', 'downloadJs', 'fileSaver'
    ],

    function(
        ko, _, atn, allCharts, analyticsConfig, chartApi, chartExporting, config, utils, jsZip, downloadJs, fileSaver
    ) {
        'use strict';
        /**
         * [overlayVisible observable to get/set if the overlay is displayed or not.]
         * @type {ko.observable}
         */
        var overlayVisible = ko.observable(false);

        var allChartIdList = ko.observableArray([]);

        var viewmodel = {
            activate: activate,
            initCsvDownloadForm: initCsvDownloadForm,
            isInternetExplorer: atn.utils.isInternetExplorer(),
            overlayVisible: overlayVisible,
            messages: atn.config.messages,
            downloadCsv: downloadCsv,
            cancel: cancel,
            allChartIdList: allChartIdList
        };

        return viewmodel;

        function activate() {

        }

        /**
         * [downloadCsv the download click handler]
         * @return {undefined}
         */
        function downloadCsv(data, event) {

            var selectedChartList = [];
            _.forEach(allChartIdList(), function(chart) {
                if (chart.isSelected()) {
                    selectedChartList.push({
                        chartId: chart.chartId,
                        chartName: chart.chartName
                    });
                }
            });

            if (selectedChartList.length) {
                if (atn.utils.getBrowserName() === 'Safari') {
                    var csvString = '';

                    _.forEach(selectedChartList, function(chart) {
                        csvString += '\n' + chart.chartName + '\n\n' + chartExporting.csvFromHighcharts(document.querySelectorAll('[atn-chart=' + chart.chartId + ']')[0]);
                    });

                    window.open('data:text/csv;charset=utf-8,' + encodeURI(csvString));

                    onCsvDownloadComplete();
                } else {
                    downloadZippedCsv(selectedChartList).then(
                        onCsvDownloadComplete
                    );
                }
            } else {
                atn.toasterRegistry.addToasterMessage(atn.config.messages.csvDownload.noChartSelected);
            }

            return false;
        }

        /**
         * [onCsvDownloadComplete on]
         * @return {[type]} [description]
         */
        function onCsvDownloadComplete() {
            toggleOverlay();
            _.delay(atn.toasterRegistry.addToasterMessage, 700, atn.config.messages.csvDownload.downloadSuccessful);
        }

        /**
         * [downloadZippedCsv function to download chart csvs as zip file]
         * @param  {Array} selectedChartList [the selected charts Array of objects]
         * @return {Promise} [promise to downloadt he zipped csv files]
         */
        function downloadZippedCsv(selectedChartList) {
            var csvString,
                fileName,
                zip = new jsZip();

            _.forEach(selectedChartList, function(chart) {
                csvString = chartExporting.csvFromHighcharts(document.querySelectorAll('[atn-chart=' + chart.chartId + ']')[0]);
                fileName = chart.chartName + '.csv';
                addFilesToZippedBlob(zip, fileName, csvString);
            });

            var zipDownloadPromise = zip.generateAsync({
                type: "blob"
            });

            zipDownloadPromise.then(
                saveZipFileCallback,
                function(e) {
                    showError(e);
                }
            );

            return zipDownloadPromise;
        }

        /**
         * [addFilesToZippedBlob add indivudial chart csv strings to the zip blob]
         * @param {Object} zip       [the jsZip library's object]
         * @param {String} csvString [the comma separated csv String]
         */
        function addFilesToZippedBlob(zip, fileName, csvString) {
            zip.file(
                fileName,
                new Blob([decodeURIComponent(encodeURI(csvString))], {
                    type: "text/csv;charset=utf-8;"
                }), {
                    binary: true
                }
            );
        }

        /**
         * [saveZipFileCallback save the zip file using fileSacer saveAs function]
         * @param  {blob object} zippedFile [the zip blob]
         * @return undefined
         */
        function saveZipFileCallback(zippedFile) {
            fileSaver(zippedFile, "charts.zip");
        }

        /**
         * [initCsvDownloadForm initialize the csv download form and windew]
         * @return {undefined}
         */
        function initCsvDownloadForm() {
            allChartIdList(_.map(allCharts.dashboardChartList(), function(chart) {
                return {
                    chartName: chart.labelsAndStrings.TITLE,
                    chartId: chart.chartConfig.chartId,
                    isSelected: ko.observable(false)
                };
            }));
            _.forEach(allChartIdList(), function(singleChert) {
                singleChert.isSelected(false);
            });

            toggleOverlay();
        }

        /**
         * [toggleOverlay toggle the csvDwonload form overlay]
         * @return {undefined}
         */
        function toggleOverlay() {
            overlayVisible(!overlayVisible());
        }

        /**
         * [toggleOverlay toggle the csvDwonload form overlay]
         * @return {undefined}
         */
        function cancel() {
            if (overlayVisible.peek()) {
                overlayVisible(!overlayVisible());
            }
        }
    });

